import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a telephone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    clientname: {
      validations: [
        { type: 'required', message: 'Please provide a company name' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please provide the type of event' }
      ]
    },
    sitename: {
      validations: []
    },
    notes: {
      validations: [
        { type: 'required', message: 'Please provide details' },
      ]
    }, 
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    starttime: {
      validations: [
        { type: 'required', message: 'Please provide an access time' }
      ]
    },
    endtime: {
      validations: [
        { type: 'required', message: 'Please provide a finish time' }
      ]
    },
    eventextra3: {
      validations: []
    },
    eventextra4: {
      validations: []
    },
    eventextra5: {
      validations: []
    },
    eventextra6: {
      validations: []
    },  
    eventextra7: {
      validations: []
    },  
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Number*',
           mapping: 'telnumber'
         }
       ]
     },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'email'
          },
         ]
        },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Company name*',
              mapping: 'clientname'
            },
           ]
          },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Number of people',
                mapping: 'plannedguestcount'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Type of event*',
                mapping: 'theme'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Preferred Room',
                mapping: 'sitename'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text-area',
                size: 'Medium',
                label: 'Catering Requirements*',
                mapping: 'notes'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Room Set Preference',
                mapping: 'eventextra3'
              }
            ]
          },
          {
            fields: [
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'What date are you interested in?*',
              mapping: 'eventDate'
            }
          ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Access Time*',
                options: [
                  { label: '6:00AM'  , value: '06:00:00'},
                  { label: '6:30AM'  , value: '06:30:00'}, 
                  { label: '7:00AM'  , value: '07:00:00'},
                  { label: '7:30AM'  , value: '07:30:00'},
                  { label: '8:00AM'  , value: '08:00:00'},
                  { label: '8:30AM'  , value: '08:30:00'},
                  { label: '9:00AM'  , value: '09:00:00'},
                  { label: '9:30AM'  , value: '09:30:00'},
                  { label: '10:00AM' , value: '10:00:00'},
                  { label: '10:30AM' , value: '10:30:00'},
                  { label: '11:00AM' , value: '11:00:00'},
                  { label: '11:30AM' , value: '11:30:00'},
                  { label: '12:00PM' , value: '12:00:00'},
                  { label: '12:30PM' , value: '12:30:00'},
                  { label: '1:00PM'  , value: '13:00:00'},
                  { label: '1:30PM'  , value: '13:30:00'},
                  { label: '2:00PM'  , value: '14:00:00'},
                  { label: '2:30PM'  , value: '14:30:00'},
                  { label: '3:00PM'  , value: '15:00:00'},
                  { label: '3:30PM'  , value: '15:30:00'},
                  { label: '4:00PM'  , value: '16:00:00'},
                  { label: '4:30PM'  , value: '16:30:00'},
                  { label: '5:00PM'  , value: '17:00:00'},
                  { label: '5:30PM'  , value: '17:30:00'},
                  { label: '6:00PM'  , value: '18:00:00'},
                  { label: '6:30PM'  , value: '18:30:00'},
                  { label: '7:00PM'  , value: '19:00:00'},
                  { label: '7:30PM'  , value: '19:30:00'},
                  { label: '8:00PM'  , value: '20:00:00'},
                  { label: '8:30PM'  , value: '20:30:00'},
                  { label: '9:00PM'  , value: '21:00:00'},
                  { label: '9:30PM'  , value: '21:30:00'},
                  { label: '10:00PM' , value: '22:00:00'}, 
                  { label: '10:30PM' , value: '22:30:00'}, 
                  { label: '11:00PM' , value: '23:00:00'}, 
                  { label: '11:30PM' , value: '23:30:00'}, 
                  { label: '12:00AM' , value: '24:00:00'}, 
                  { label: '12:30AM' , value: '24:30:00'}, 
                  { label: '1:00AM'  , value: '01:00:00'}, 
                  { label: '1:30AM'  , value: '01:30:00'}, 
                  { label: '2:00AM'  , value: '02:00:00'} 
                ],
                mapping: 'starttime'
              },
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Finish Time*',
                options: [
                  { label: '6:00AM'  , value: '06:00:00'},
                  { label: '6:30AM'  , value: '06:30:00'}, 
                  { label: '7:00AM'  , value: '07:00:00'},
                  { label: '7:30AM'  , value: '07:30:00'},
                  { label: '8:00AM'  , value: '08:00:00'},
                  { label: '8:30AM'  , value: '08:30:00'},
                  { label: '9:00AM'  , value: '09:00:00'},
                  { label: '9:30AM'  , value: '09:30:00'},
                  { label: '10:00AM' , value: '10:00:00'},
                  { label: '10:30AM' , value: '10:30:00'},
                  { label: '11:00AM' , value: '11:00:00'},
                  { label: '11:30AM' , value: '11:30:00'},
                  { label: '12:00PM' , value: '12:00:00'},
                  { label: '12:30PM' , value: '12:30:00'},
                  { label: '1:00PM'  , value: '13:00:00'},
                  { label: '1:30PM'  , value: '13:30:00'},
                  { label: '2:00PM'  , value: '14:00:00'},
                  { label: '2:30PM'  , value: '14:30:00'},
                  { label: '3:00PM'  , value: '15:00:00'},
                  { label: '3:30PM'  , value: '15:30:00'},
                  { label: '4:00PM'  , value: '16:00:00'},
                  { label: '4:30PM'  , value: '16:30:00'},
                  { label: '5:00PM'  , value: '17:00:00'},
                  { label: '5:30PM'  , value: '17:30:00'},
                  { label: '6:00PM'  , value: '18:00:00'},
                  { label: '6:30PM'  , value: '18:30:00'},
                  { label: '7:00PM'  , value: '19:00:00'},
                  { label: '7:30PM'  , value: '19:30:00'},
                  { label: '8:00PM'  , value: '20:00:00'},
                  { label: '8:30PM'  , value: '20:30:00'},
                  { label: '9:00PM'  , value: '21:00:00'},
                  { label: '9:30PM'  , value: '21:30:00'},
                  { label: '10:00PM' , value: '22:00:00'}, 
                  { label: '10:30PM' , value: '22:30:00'}, 
                  { label: '11:00PM' , value: '23:00:00'}, 
                  { label: '11:30PM' , value: '23:30:00'}, 
                  { label: '12:00AM' , value: '24:00:00'}, 
                  { label: '12:30AM' , value: '24:30:00'}, 
                  { label: '1:00AM'  , value: '01:00:00'}, 
                  { label: '1:30AM'  , value: '01:30:00'}, 
                  { label: '2:00AM'  , value: '02:00:00'} 
                ],
                mapping: 'endtime'
              },
            ]
          },
          {
            fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'AV requirement',
              mapping: 'eventextra4'
            }
          ]
          },
          {
            fields: [
              {
                type: 'radio-buttons',
                size: 'Medium',
                label: 'Require Wi-Fi?',
                options: [
                  { label: 'Yes' , value: 'Yes'},
                  { label: 'No', value: 'No' },
                ],
                mapping: 'eventextra5'
              }
            ]
          },
          {
            fields: [
              {
                type: 'radio-buttons',
                size: 'Medium',
                label: 'Require tablecloths?',
                options: [
                  { label: 'Yes' , value: 'Yes'},
                  { label: 'No', value: 'No' },
                ],
                mapping: 'eventextra6'
              }
            ]
          },
          {
            fields: [
              {
                type: 'radio-buttons',
                size: 'Medium',
                label: 'Interested in cultural engagement?',
                options: [
                  { label: 'Yes' , value: 'Yes'},
                  { label: 'No', value: 'No' },
                ],
                mapping: 'eventextra7'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Manaaki Management Contact Form',
    formId: '166',
    clientKey: '2415BF26-C9CB-4C01-8162-A2EB4D69FADB',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Kia ora – your request has been submitted, we will be in contact. Ngā mihi – The Wellington Functions Team',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/manaaki/form_structure.js